import api from '../config/api';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.superchargeme.com';
const BASE_PATH = `${API_BASE}/api/accounting/cashflow-projection`;

export const getProjection = async (params = {}) => {
  const response = await api.get(`${BASE_PATH}/projection`, { params });
  return response.data;
};

export const getEvents = async (params = {}) => {
  const response = await api.get(`${BASE_PATH}/events`, { params });
  return response.data;
};

export const getAssumptions = async () => {
  const response = await api.get(`${BASE_PATH}/assumptions`);
  return response.data;
};

export const putAssumptions = async (assumptions) => {
  const response = await api.put(`${BASE_PATH}/assumptions`, assumptions);
  return response.data;
};

export const getPlannedPos = async () => {
  const response = await api.get(`${BASE_PATH}/planned-pos`);
  return response.data;
};

export const createPlannedPo = async (po) => {
  const response = await api.post(`${BASE_PATH}/planned-pos`, po);
  return response.data;
};

export const patchPlannedPo = async (id, patch) => {
  const response = await api.patch(`${BASE_PATH}/planned-pos/${id}`, patch);
  return response.data;
};

export const getReorderSuggestions = async () => {
  const response = await api.get(`${BASE_PATH}/reorder-suggestions`);
  return response.data;
};

export const planPayment = async (payload) => {
  const response = await api.post(`${BASE_PATH}/plan-payment`, payload);
  return response.data;
};

export const cancelPlannedPayment = async (milestoneId) => {
  const response = await api.delete(`${BASE_PATH}/plan-payment/${milestoneId}`);
  return response.data;
};

export const markInvoicePaid = async (invoiceId, payload = {}) => {
  const response = await api.post(`${API_BASE}/api/accounting/invoices/${invoiceId}/mark-paid`, payload);
  return response.data;
};

export const formatCurrency = (value, currency = 'USD') => {
  const n = Number(value || 0);
  // Always whole dollars: the old <$10k-shows-cents rule put "$115.66" next to
  // "$80,619" in the same column, which reads as ~$115k at a glance. Projection
  // figures have no meaningful cents.
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(n);
};

export const formatCompactCurrency = (value, currency = 'USD') => {
  const n = Number(value || 0);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    notation: 'compact',
    maximumFractionDigits: Math.abs(n) >= 100000 ? 1 : 0,
  }).format(n);
};

export const formatDate = (value) => {
  if (!value) return '—';
  const d = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

const cashflowProjectionService = {
  getProjection,
  getEvents,
  getAssumptions,
  putAssumptions,
  getPlannedPos,
  createPlannedPo,
  patchPlannedPo,
  getReorderSuggestions,
  planPayment,
  cancelPlannedPayment,
  markInvoicePaid,
};

export default cashflowProjectionService;
